module.exports = __webpack_public_path__ + "img/paladin.d413516c.png";